






















export default {
    name: "SortiItem",
    props: {
        equipement: Object,
        mouvement: Object,
        jours: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        destination: function () {
            return this.mouvement ? this.mouvement.destination_str : "";
        },
        dureeClass: function () {
            return this.jours > 14 ? "danger" : this.jours > 7 ? "warn" : "ok";
        },
        dureeLabel: function () {
            if (this.jours === 0) {
                return "Aujourd'hui";
            }
            if (this.jours === 1) {
                return "Hier";
            }
            return "Depuis " + this.jours + " jours";
        },
    },
};
